import {
	Box,
	FormControlLabel,
	FormGroup,
	Checkbox,
	Typography,
	Grid,
	makeStyles,
	Divider,
} from '@material-ui/core';
import ImageKit from 'components/Image';
import convertToToman from 'services/toman';
import Tick from 'assets/img/Checkbox.png';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '400px',
		[theme.breakpoints.between('xs', 'sm')]: {
			width: (props) =>
				props.isCheckbox ? 'calc(100vw - 60px)' : props.paid ? 'calc(100vw - 25px)' : 'calc(100vw - 60px)',
		},
	},
}));

const DebtItems = (props) => {
	const { debtOptions, isCheckbox, item, index, handleChange, ...innerProps } = props;
	const classes = useStyles({ paid: !item.paid, isCheckbox: isCheckbox });

	return (
		<Grid container>
			<Grid xs={12} item>
				<Box display={'flex'} justifyContent="space-between">
					<FormGroup row style={{ width: '100%' }}>
						<FormControlLabel
							onChange={(e) => (item.paid ? {} : handleChange(e, item.pay))}
							classes={{
								label: classes.root,
							}}
							control={
								item.paid ? (
									<Box width={40} height={40} display="flex" justifyContent={'center'} alignItems={'center'}>
										<ImageKit src={Tick} width={24} height={24} />
									</Box>
								) : isCheckbox ? (
									<Checkbox
										name={item.id}
										inputProps={{ 'aria-label': 'primary checkbox' }}
										color="primary"
										checked={innerProps.checked}
									/>
								) : (
									<></>
								)
							}
							label={
								<Box display="flex" justifyContent="space-between" alignItems="center">
									<Box marginLeft={'8px'} display={'flex'} flexDirection="column">
										<Typography style={{ color: '#000000', fontSize: 14, fontWeight: 700, marginBottom: 8 }}>
											{item.name}
										</Typography>

										{item.paid && (
											<Typography style={{ color: '#14AC88', fontSize: 12, fontWeight: 500 }}>
												پرداخت شده
											</Typography>
										)}

										{!item.paid && (
											<Typography style={{ color: '#888BA0', fontSize: 12, fontWeight: 500 }}>{`قسط ${
												index + 1
											} از ${debtOptions.length}`}</Typography>
										)}

										{item?.error && (
											<Typography style={{ color: '#E21344', fontSize: 12, fontWeight: 500 }}>{`قسط${
												index + 1
											} از ${debtOptions.length}`}</Typography>
										)}
									</Box>

									<Box display={'flex'} alignItems="center">
										<Typography style={{ fontSize: 18, fontWeight: 700, color: '#101740' }}>
											{convertToToman(item.pay)}
										</Typography>
										<Typography style={{ fontSize: 12, fontWeight: 500, color: '#101740', marginRight: 4 }}>
											تومان
										</Typography>
									</Box>
								</Box>
							}
						/>
					</FormGroup>
				</Box>
			</Grid>
			{index + 1 <= debtOptions.length - 1 && (
				<Divider style={{ width: '100%', background: '#E9E9F0', height: 1, margin: '16px 0' }} />
			)}
		</Grid>
	);
};
DebtItems.defaultProps = {
  isCheckbox: true,
  debtOptions: [],
  // classes: {
  //   root: {}
  // }
};
export default DebtItems;
